import { useMemo } from 'react';

import { useNetworkManager } from './useNetworkManager';

export const usePrimaryColor = (): string => {
  const { brandingData } = useNetworkManager();
  return useMemo(() => {
    if (brandingData) {
      return brandingData[0].welcome_logo_bgcolor;
    }
    return '#FFF';
  }, [brandingData]);
};
